import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

function Header({ isAuthenticated }) {
  return (
    <header className="header">
      <Link to="/" className="header-title">
        <h1>Cloud Top Chat</h1>
      </Link>
      <div className="header-buttons">
        {!isAuthenticated ? (
          <>
            <Link to="/signup">
              <button>Sign Up</button>
            </Link>
            <Link to="/login">
              <button>Login</button>
            </Link>
          </>
        ) : (
          <>
            <Link to="/chat">
              <button>Chat</button>
            </Link>
            <Link to="/logout">
              <button className="logout-btn">Logout</button>
            </Link>
          </>
        )}
      </div>
    </header>
  );
}

export default Header;